/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import {Component, OnInit} from '@angular/core';
import {DividerBlock} from '../../classes/Elements';
import {createBorder, createPadding} from '../../utils';
import {AbstractBlock} from '../abstract-block';

@Component({
  selector: 'ip-divider',
  template: '<div [ngStyle]="getDividerStyles()"></div>',
  styles: [
      `
      :host {
        display: table;
        width: 100%;
      }
    `
  ]
})
export class DividerComponent extends AbstractBlock<DividerBlock> implements OnInit {
  // @Input()
  // block: DividerBlock = new DividerBlock();

  getDividerStyles() {
    const {border, padding} = this.block.options;
    return {
      ...createBorder(border, 'borderTop'),
      ...createPadding(padding, 'margin')
    };
  }

  ngOnInit() {
  }
}
